import * as React from 'react';

import classes from './styles.module.scss';

export const PreWrapper: React.StatelessComponent = ({ children }) => (
  <pre className={classes.preWrapper}>{children}</pre>
);
